import { ReactNode } from 'react'
import { libreBaskerville as editorial } from '@/fonts'
import styles from './integrations.module.css'

export function Banner({
  category,
  children
}: {
  category?: string
  children?: ReactNode
}): JSX.Element {
  return (
    <header className={styles.banner}>
      <div className={styles.container}>
        <h1 className={`${styles.title} ${editorial.className}`}>
          {category
            ? `${category} integrations`
            : 'Your forms. Your favorite tools.'}
        </h1>
        <p className={styles.description}>
          {category
            ? `Explore ${category.toLowerCase()} tools that work with HeyForm. Find an app and follow its setup guide.`
            : 'Send responses to your spreadsheets, notify your team, and keep your workflow moving. Find the connection you need.'}
        </p>
        {children}
      </div>
    </header>
  )
}
